export default {
  name: "ChargesPreCheckinGrid",
  props: {
    headers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loadingItems: {
      type: Boolean,
      default: false
    },
    rowsPerPage: {
      type: Number,
      default: 25
    },
    serverSide: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: true
    },
    totalItems: {
      type: Number
    },
    totalPages: {
      type: Number
    },
    addPage: {
      type: String,
      default: ""
    },
    paginationText: {
      type: String
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    phpServer: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalFormated: {
      type: String,
      default: "R$ 0,00"
    }
  },
  data() {
    return {
      order: "desc",
      sort: "",
      pagination: {}
    };
  },
  methods: {
    sortPage(header) {
      this.order === "desc" ? (this.order = "asc") : (this.order = "desc");
      this.sort = header.value;
      header.sortable &&
        this.$emit("sortPage", {
          sort: header.value,
          order: this.order
        });
    },
    changePage: function(page) {
      this.callPage(page);
    },
    lastPage: function() {
      this.callPage(this.totalPages);
    },
    firstPage: function() {
      this.callPage(1);
    },
    callPage: function(payload) {
      const page = this.phpServer ? payload : payload - 1;
      this.$emit("changePage", page);

      this.page = payload;
      this.schollToElement();
    },
    schollToElement() {
      const el = document.getElementById("list-items");
      el.scrollIntoView();
    }
  },
  created() {},
  computed: {
    perPageAndTotal() {
      const multiplyPageRowsPerPage = this.page * this.rowsPerPage;

      const firstComparation =
        this.totalItems === 0 ? this.totalItems : this.page;

      const secondComparation =
        multiplyPageRowsPerPage - (this.rowsPerPage - 1);

      const firstNumber =
        this.page === 1 ? firstComparation : secondComparation;

      const secondNumber =
        multiplyPageRowsPerPage > this.totalItems
          ? this.totalItems
          : multiplyPageRowsPerPage;

      return `${
        !this.totalItems || this.totalItems === 0 ? 0 : firstNumber
      } - ${!this.totalItems || this.totalItems === 0 ? 0 : secondNumber}  ${
        this.paginationText
      } ${this.totalItems | 0}`;
    },
    page: {
      get() {
        return this.currentPage;
      },
      set(page) {
        return page;
      }
    }
  }
};
